/**
 * NEXUMA — i18n Configuration
 *
 * Uses i18next + react-i18next with static imports (no lazy loading required
 * since translation files are small). Supports sq (Albanian), en, de.
 *
 * Language resolution order:
 *  1. Saved user preference in localStorage ('nexuma_lang')
 *  2. Fallback: 'sq' (Albanian is the default; browser language is ignored)
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import sqTranslation from './locales/sq/translation.json';
import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'sq', nativeName: 'Shqip',   flag: '🇽🇰', flagSrc: '/icons/flag-xk.svg' },
  { code: 'en', nativeName: 'English', flag: '🇬🇧' },
  { code: 'de', nativeName: 'Deutsch', flag: '🇩🇪' },
];

export const LANG_STORAGE_KEY = 'nexuma_lang';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      sq: { translation: sqTranslation },
      en: { translation: enTranslation },
      de: { translation: deTranslation },
    },
    fallbackLng: 'sq',
    supportedLngs: ['sq', 'en', 'de'],
    detection: {
      // Honor an explicit ?lng= link, then a saved preference; otherwise fall
      // back to 'sq' (ignore navigator language so Albanian is default for new users).
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    // Return key as fallback if translation is missing (prevents empty labels)
    returnNull: false,
    returnEmptyString: false,
  });

// Suppress the Locize promo message in console
['log', 'info'].forEach((method) => {
  const orig = console[method];
  console[method] = function (...args) {
    if (args.some((a) => typeof a === 'string' && a.includes('Locize'))) return;
    return orig.apply(console, args);
  };
});

export default i18n;
